import type { CollectionModelDrawableVerticalSeparation } from '../../model/collection/drawable/vertical.separation.drawable';
import type { SVGRenderOptions } from '../draw/svg/svg.render';
import { m } from '../mithril';
import { StyleConfig } from '../theme';
import { LabelSVGDraw } from './label.draw.svg';
import { SVGUtil } from './util.draw.svg';

export class VerticalSeparationSVGDraw {
	static view(drawable: CollectionModelDrawableVerticalSeparation, options: SVGRenderOptions) {
		if (!drawable.isVisible || !options.isVerticalSeparationEnabled) {
			return null;
		}

		const indexOffset = drawable.indexInGroupWithSameTopMarker() * StyleConfig.STROKE_WIDTH * 4;

		return m(
			'g',
			{
				id: `vertical-separation-${drawable.id}`,
			},
			[
				LabelSVGDraw.view(drawable.label, options),

				// Draw the vertical separation clearance line (vertical line between the top and bottom markers).
				// If the label is on the left side, draw this line on the left side of the pole.
				// Otherwise, draw it on the right side of the pole.
				SVGUtil.DrawLineBordered(
					{
						x: drawable.label.isOnLeftSide()
							? drawable.topMarker.x - options.draw.state.markerOffsetWidth + indexOffset
							: drawable.topMarker.x + options.draw.state.markerOffsetWidth - indexOffset,
						y: drawable.topMarker.y,
					},
					{
						x: drawable.label.isOnLeftSide()
							? drawable.bottomMarker.x - options.draw.state.markerOffsetWidth + indexOffset
							: drawable.bottomMarker.x + options.draw.state.markerOffsetWidth - indexOffset,
						y: drawable.bottomMarker.y,
					},
					options.scale,
					drawable.clearanceThresholdInMeters ? (drawable.isInClearance ? 'lime' : 'red') : StyleConfig.STROKE_SECONDARY
				),
			]
		);
	}
}
